module.exports = __webpack_public_path__ + "img/lostTimeTop.922efafb.svg";